import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleRight } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'reactstrap';

import {
  toggleCheckoutModal,
} from 'Redux/ducks/modal';
import store from 'Redux/store';
import HitLinkTo from 'Helpers/Product/HitLinkTo';

// todo remove path and productID, get from hit
export default function CardViewBtn({ place, hit, noFauxLink, clickFunction, toggleModal }) {
  const onViewClick = () => {
    if (place === 'Checkout Modal') {
      store.dispatch(toggleCheckoutModal());
      store.dispatch({ type: 'frontend/checkout-modal/VIEWED_FROM_CHECKOUT_MODAL', payload: { productId: hit.product_id || hit._id } });
    }

    if (['Mega Menu', 'Deep Discount Exit Intent'].includes(place)) {
      clickFunction();
    }

    if (place === 'BundleEbookAndSoftwareLastChance') {
      store.dispatch({
        type: 'frontend/click/CLICK_INTERACTION',
        payload: { section: 'CheckoutGiftButton', value: HitLinkTo(hit).pathname },
      });
    }

    toggleModal();
  };

  return (
    <Button
      color="link"
      tag={Link}
      to={HitLinkTo(hit)}
      className={classNames(
        'btn-reset-style',
        'text-decoration-none',
        { 'faux-block-link__overlay-link': !noFauxLink },
      )}
      onClick={onViewClick}
    >
      <div className="btn btn-primary">
        <FontAwesomeIcon icon={faCircleRight} className="mr-1" />
        <div className="btn-text-container">
          <FormattedMessage id="button.view" defaultMessage="View" />
        </div>
      </div>
    </Button>
  );
}

CardViewBtn.propTypes = {
  place: PropTypes.string,
  hit: PropTypes.shape({}),
  noFauxLink: PropTypes.bool,
  clickFunction: PropTypes.func,
  toggleModal: PropTypes.func,
};

CardViewBtn.defaultProps = {
  place: '',
  hit: {},
  noFauxLink: false,
  clickFunction: () => { },
  toggleModal: () => { },
};
